import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import { Menu as AntMenu, Modal, Spin } from 'antd';
import { FormattedMessage } from 'react-intl';
import engine from 'store/src/store-engine';
import sessionStorages from 'store/storages/sessionStorage';
import plugins from 'store/plugins/expire';
import wrapReact from '../../../../../util/react';
import FormSetting from './formSetting';
import FormPassword from './formPassword';
import { actUI } from '../../../../../redux/action/ui';
import {
  getCiamDomain,
  getCiamAppName,
  getCiamClientId,
  getCiamRedirectUriForLogout,
} from '../../../../../util/url';

const { SubMenu } = AntMenu;
const sessionStore = engine.createStore(sessionStorages, plugins);
const userIcon = require('../../../../../static/image/user-icon.png');
const mySettingIcon = require('../../../../../static/image/my setting-icon.png');
const loginOutIcon = require('../../../../../static/image/logout-icon.png');
const changePwdIcon = require('../../../../../static/image/change password-icon.png');

export class Menu extends Component {
  handleClick = ({ key }) => {
    const { handleLogout } = this.props;
    if (key === 'logout') {
      handleLogout();
      sessionStore.set('privacvNotice', null);
      sessionStore.set('isFirstLogin', null);
      const lang = sessionStore.get('lang') || 'en';
      // eslint-disable-next-line max-len
      // window.location.href = `${getCiamDomain()}/v2/logout?client_id=${getCiamClientId()}&post_logout_redirect_uri=${getCiamRedirectUriForLogout()}&lang=${lang}`;
      // edit by sam 20240619 for uat env
      window.location.href = `${getCiamDomain()}/oidc/logout?client_id=${getCiamClientId()}&post_logout_redirect_uri=${getCiamRedirectUriForLogout()}&lang=${lang}`;
    } else if (key === 'mySetting') {
      this.handleClickSetting();
    } else if (key === 'changePassword') {
      this.handleClickPassword();
    }
  }

  handleClickSetting = () => {
    // const { dispatch } = this.props;
    // actUI(dispatch, {
    //   uiIndex: { uiHeader: { uiMenuUser: { dialogState: 'SETTING' } } },
    // });
    const lang = sessionStore.get('lang') || 'en';
    console.log('lang = ', lang);
    window.location.href = `${getCiamDomain()}/identity/profile?app=${getCiamClientId()}&lang=${lang}`;
  }

  handleClickPassword = () => {
    // const { dispatch } = this.props;
    // actUI(dispatch, {
    //   uiIndex: { uiHeader: { uiMenuUser: { dialogState: 'PASSWORD' } } },
    // });
    const lang = sessionStore.get('lang') || 'en';
    window.location.href = `${getCiamDomain()}/identity/idmspasswordupdate?app=${getCiamAppName()}&lang=${lang}`;
  }

  handleCancel = () => {
    const { dispatch } = this.props;
    actUI(dispatch, {
      uiIndex: { uiHeader: { uiMenuUser: { dialogState: null } } },
    });
  }

  handleSubmit = (data, cb) => {
    const { dispatch } = this.props;
    const callback = (res) => {
      if (res.status === 'SUCCESS') {
        actUI(dispatch, {
          uiIndex: { uiHeader: { uiMenuUser: { dialogState: null } } },
        });
      }
      cb(res);
    };
    const { ui, updateUser, changePwd } = this.props;
    const { dialogState } = ui;
    if (dialogState === 'SETTING') {
      updateUser(data, callback);
    } else if (dialogState === 'PASSWORD') {
      changePwd(data, callback);
    }
  }

  render() {
    const {
      intl, ui, filePath, className, user, auth, dispatch,
    } = this.props;
    const { formatMessage } = intl;
    const { dialogState } = ui;
    const { email } = user;
    let flag = false;
    if (email) {
      flag = false;
      // const str = email.split('@')[1];
      // console.log('str-0218:', str);
      // const len = str.length;
      // if (len > 6) {
      //   const strSub = str.substring(len - 7);
      //   if (strSub === '.se.com') {
      //     flag = false;
      //   }
      // } else if (str === 'se.com') {
      //   flag = false;
      // }
    }
    return (
      <AntMenu
        mode="horizontal"
        onClick={this.handleClick}
        className={`${filePath} ${className}`}
        selectedKeys={[]}
      >
        <SubMenu
          key="0"
          title={(
            <span>
              {/* <Icon type="user" /> */}
              <img src={userIcon} alt="" />
              <Spin spinning={user.firstName === ''}>
                {intl.locale === 'zh'
                  ? user.lastName + user.firstName
                  : `${user.firstName} ${user.lastName}`}
              </Spin>
            </span>
          )}
          className="menu-user"
          popupClassName="menu-user-submenu"
        >
          <AntMenu.Item key="mySetting" className="item-setting">
            <img src={mySettingIcon} alt="" />
            <FormattedMessage
              id="Header.mySetting"
              defaultMessage="my setting"
            />
          </AntMenu.Item>
          {
            flag && (
            <AntMenu.Item key="changePassword" className="item-password">
              <img src={changePwdIcon} alt="" />
              <span className="item-msg">
                <FormattedMessage
                  id="Header.changePassword"
                  defaultMessage="change password"
                />
              </span>
            </AntMenu.Item>
            )
          }
          <AntMenu.Item key="logout" className="item-logout">
            <img src={loginOutIcon} alt="" />
            <span className="item-msg">
              <FormattedMessage id="Header.logout" defaultMessage="logout" />
            </span>
          </AntMenu.Item>
        </SubMenu>
        <Modal
          title={
            (dialogState === 'SETTING'
              && formatMessage({
                id: 'Header.mySetting',
                defaultMessage: 'my setting',
              }))
            || (dialogState === 'PASSWORD'
              && formatMessage({
                id: 'app.auth.password',
                defaultMessage: 'password',
              }))
          }
          visible={dialogState !== null}
          maskClosable={false}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText={formatMessage({ id: 'app.btn.ok', defaultMessage: 'ok' })}
          cancelText={formatMessage({
            id: 'app.btn.cancel',
            defaultMessage: 'cancel',
          })}
          footer={null}
          className="container_index_header_menu_MenuUser_dialog"
        >
          {dialogState === 'SETTING' && (
            <FormSetting
              auth={auth}
              user={user}
              onSubmit={this.handleSubmit}
              onCancel={this.handleCancel}
              ui={ui.uiFormSetting}
              dispatch={dispatch}
            />
          )}
          {dialogState === 'PASSWORD' && (
            <FormPassword
              onSubmit={this.handleSubmit}
              onCancel={this.handleCancel}
              ui={ui.uiFormPassword}
              dispatch={dispatch}
            />
          )}
        </Modal>
      </AntMenu>
    );
  }
}

Menu.propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  ui: PropTypes.shape({
    dialogState: PropTypes.oneOf(['SETTING', 'PASSWORD', null]),
    uiFormPassword: PropTypes.object.isRequired,
    uiFormSetting: PropTypes.object.isRequired,
  }).isRequired,
  handleLogout: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  changePwd: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default wrapReact(Menu, 'container_index_header_menu_MenuUser');
